export default __webpack_public_path__ + "static/media/witch.eb4df4ad.png";